var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.userData
    ? _c(
        "div",
        [
          _c("div", { staticClass: "gl-forms__container" }, [
            _c("div", { staticClass: "gl-forms__title" }, [
              _vm._v(" " + _vm._s(_vm.$t("profile.info")) + " ")
            ]),
            _c("div", { staticClass: "gl-grid-form" }, [
              _c(
                "div",
                { staticClass: "form__group col-2" },
                [
                  _c("gl-input", {
                    directives: [
                      {
                        name: "skeletor",
                        rawName: "v-skeletor:onChange",
                        value: _vm.setValue,
                        expression: "setValue",
                        arg: "onChange"
                      }
                    ],
                    attrs: {
                      id: "profile.name",
                      type: "text",
                      label: _vm.$t("nouns.firstName"),
                      placeholder: _vm.$t("nouns.firstName"),
                      mandatory: true,
                      value: _vm.$v.form.name.$model,
                      errormessage:
                        !_vm.$v.form.name.required &&
                        _vm.$v.form.name.$model !== null
                          ? _vm.$t("account.errors.fieldRequired")
                          : null
                    },
                    model: {
                      value: _vm.$v.form.name.$model,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.$v.form.name,
                          "$model",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "$v.form.name.$model"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "form__group col-2" },
                [
                  _c("gl-input", {
                    directives: [
                      {
                        name: "skeletor",
                        rawName: "v-skeletor:onChange",
                        value: _vm.setValue,
                        expression: "setValue",
                        arg: "onChange"
                      }
                    ],
                    attrs: {
                      id: "profile.surname",
                      type: "text",
                      label: _vm.$t("nouns." + Object.keys(_vm.form)[1]),
                      placeholder: _vm.$t("nouns." + Object.keys(_vm.form)[1]),
                      mandatory: true,
                      value: _vm.$v.form.surname.$model
                    },
                    model: {
                      value: _vm.$v.form.surname.$model,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.$v.form.surname,
                          "$model",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "$v.form.surname.$model"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "form__group col-1" },
                [
                  _c("gl-input", {
                    directives: [
                      {
                        name: "skeletor",
                        rawName: "v-skeletor:onChange",
                        value: _vm.setValue,
                        expression: "setValue",
                        arg: "onChange"
                      }
                    ],
                    attrs: {
                      id: "profile.email",
                      type: "email",
                      label: _vm.$t("nouns." + Object.keys(_vm.form)[2]),
                      placeholder: _vm.$t("nouns." + Object.keys(_vm.form)[2]),
                      value: _vm.$v.form.email.$model,
                      readonly: true,
                      errormessage:
                        !_vm.$v.form.email.required &&
                        _vm.$v.form.email.$model !== null
                          ? _vm.$t("account.errors.fieldRequired")
                          : _vm.$v.form.email.$error ||
                            _vm.$v.form.email.$invalid
                          ? _vm.errorMessages.email
                          : null
                    },
                    model: {
                      value: _vm.$v.form.email.$model,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.$v.form.email,
                          "$model",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "$v.form.email.$model"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "form__group col-2-fullrow" },
                [
                  _c("gl-select", {
                    directives: [
                      {
                        name: "skeletor",
                        rawName: "v-skeletor:onChange",
                        value: _vm.setValue,
                        expression: "setValue",
                        arg: "onChange"
                      }
                    ],
                    attrs: {
                      id: "profile.lang",
                      label: _vm.$t("account.forms.selectLang"),
                      placeholder: _vm.$t("account.forms.selectLang"),
                      mandatory: true,
                      separator: true,
                      errormessage: _vm.$v.form.lang.$error
                        ? _vm.$t("account.errors.fieldRequired")
                        : null
                    },
                    domProps: {
                      options: _vm.getLanguages,
                      value: _vm.$v.form.lang.$model
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "form__group col-2-fullrow" },
                [
                  _c("gl-input", {
                    directives: [
                      {
                        name: "skeletor",
                        rawName: "v-skeletor:onChange",
                        value: _vm.setValue,
                        expression: "setValue",
                        arg: "onChange"
                      }
                    ],
                    attrs: {
                      id: "profile.surname",
                      type: "text",
                      label: _vm.$t("nouns.password"),
                      placeholder: _vm.$t("nouns.password"),
                      icon: "glicon-edit",
                      editable: false,
                      readonly: true,
                      selector: true,
                      value: "************"
                    },
                    on: {
                      onClick: function($event) {
                        return _vm.editPassword("password")
                      }
                    }
                  })
                ],
                1
              )
            ])
          ]),
          _vm.shouldShowNotificationsCfg
            ? [
                _c(
                  "div",
                  { staticClass: "gl-forms__container" },
                  [
                    _c("div", { staticClass: "gl-forms__title" }, [
                      _vm._v(" " + _vm._s(_vm.$t("admins.notifications")) + " ")
                    ]),
                    _vm.shouldShowNa2Cfg
                      ? [
                          _c("div", { staticClass: "form__row" }, [
                            _c(
                              "div",
                              { staticClass: "account__block--checkbox" },
                              [
                                _c("gl-checkbox", {
                                  directives: [
                                    {
                                      name: "skeletor",
                                      rawName: "v-skeletor:onChange",
                                      value: _vm.setNotifications,
                                      expression: "setNotifications",
                                      arg: "onChange"
                                    }
                                  ],
                                  attrs: {
                                    id: "profile.notifications.na2.enabled",
                                    label: _vm.$t("admins.mailResumeActivity"),
                                    checked:
                                      _vm.form.notificationsCfg.na2.enabled,
                                    small: true
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "form__group" },
                              [
                                _c("gl-select", {
                                  directives: [
                                    {
                                      name: "skeletor",
                                      rawName: "v-skeletor:onChange",
                                      value: _vm.setNotifications,
                                      expression: "setNotifications",
                                      arg: "onChange"
                                    }
                                  ],
                                  attrs: {
                                    id:
                                      "profile.notifications.na2.weekPeriodicity",
                                    label: _vm.$t(
                                      "admins.mailFrequencyResumeActivity"
                                    ),
                                    placeholder: _vm.$t(
                                      "admins.mailFrequencyResumeActivity"
                                    ),
                                    mandatory: true,
                                    separator: true,
                                    disabled:
                                      _vm.form.notificationsCfg.na2.enabled !==
                                      true,
                                    errormessage: !_vm.form.notificationsCfg
                                      ? _vm.$t("account.errors.fieldRequired")
                                      : null
                                  },
                                  domProps: {
                                    options: _vm.getWeekNotifications,
                                    value: String(
                                      _vm.form.notificationsCfg.na2
                                        .weekPeriodicity
                                    )
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        ]
                      : _vm._e()
                  ],
                  2
                )
              ]
            : _vm._e(),
          _c(
            "div",
            { staticClass: "gl-grid-form__buttons margin-auto" },
            [
              _c("gl-button", {
                attrs: {
                  id: "profile.btn-save",
                  "color-primary": "",
                  type: "submit",
                  text: _vm.$t("account.forms.saveChanges"),
                  disabled: _vm.$v.$invalid || !_vm.dirtyFields
                },
                on: {
                  onClick: function($event) {
                    $event.preventDefault()
                    return _vm.updateUser(_vm.form)
                  }
                }
              })
            ],
            1
          ),
          _vm.fieldToEdit
            ? _c("EditPopup", {
                attrs: {
                  "field-to-edit": _vm.fieldToEdit,
                  "password-error": _vm.passwordError
                },
                on: {
                  cancel: function($event) {
                    _vm.fieldToEdit = ""
                    _vm.passwordError = ""
                  },
                  done: _vm.updateData
                }
              })
            : _vm._e()
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }